import { useFormikContext } from 'formik';
import { FeedingSettingsType } from '../../../../../redux/types/mainObjectTypes';

import styles from './HasKidsPrice.module.scss';
import Checkbox from '../../../../../components/Checkbox';
import Tooltip from '../../../../../components/Tooltip';
import { FEEDING_KIDS_REQ } from '../../../../../utils/constants';
import { useEffect } from 'react';

const HasKidsPrice = () => {
  const {
    handleChange,
    values,
    errors,
    setFieldTouched,
    touched,
    validateField,
    setFieldValue,
    isSubmitting,
    isValidating,
  } = useFormikContext<FeedingSettingsType>();

  const resetKidsSettings = () => {
    setFieldValue('ageKidsFree', '');
    setFieldValue('kids', []);
  };

  useEffect(() => {
    if (!values.has_breakfast && !values.has_dinner && !values.has_lunch) {
      setFieldValue('has_kidsPrice', false);
    }
  }, [values]);

  useEffect(() => {
    if (!values.has_kidsPrice) {
      resetKidsSettings();
    }
  }, [values.has_kidsPrice]);

  useEffect(() => {
    if (
      values.has_kidsPrice &&
      !values.ageKidsFree &&
      values.kids.length === 0 &&
      isValidating
    ) {
      setFieldValue('has_kidsPrice', false);
    }
  }, [isValidating]);

  return (
    <div className={styles.itemLine}>
      <span>
        <Checkbox
          checked={values.has_kidsPrice}
          label="Отдельная стоимость для детей"
          name={'has_kidsPrice'}
          onClick={() => {
            setFieldTouched('has_kidsPrice');
            setFieldValue('has_kidsPrice', !values.has_kidsPrice);
          }}
          disabled={
            !values.has_breakfast && !values.has_dinner && !values.has_lunch
          }
        />
      </span>
      {values.has_kidsPrice && <Tooltip requirementsText={FEEDING_KIDS_REQ} />}
    </div>
  );
};
export default HasKidsPrice;
